<div app-daily-mileage class="mileage-group" fxLayout="column">
  <div fxLayout="column" fxFlex class="mileage-container">
    <div
      fxLayout="row"
      fxLayoutAlign="flex-start center"
      fxLayoutGap="6px"
      [formGroup]="form"
      class="mileage-filter">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        hideRequiredMarker
        class="report-type-filter">
        <mat-label>Report Type</mat-label>
        <mat-select
          name="reportType"
          placeholder="Select Report"
          formControlName="reportType">
          <!-- <mat-option value="">All</mat-option> -->
          <mat-option
            *ngFor="let reportType of reportTypes"
            [value]="reportType.value">
            {{ reportType.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        style="width: 160px"
        appDateYearMonthDisplay
        [hidden]="form.get('reportType')?.value === 'monthly'"
        floatLabel="always">
        <mat-label>Date</mat-label>
        <input
          matInput
          [max]="todayDate"
          [matDatepicker]="monthDate"
          readonly
          formControlName="monthDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="monthDate"></mat-datepicker-toggle>
        <mat-datepicker
          #monthDate
          startView="year"
          panelClass="year-month-picker"
          (yearSelected)="onChosenYearHandler($event)"
          (monthSelected)="
            onChosenMonthHandler($event, monthDate)
          "></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        style="width: 160px"
        appDateYearDisplay
        [hidden]="form.get('reportType')?.value !== 'monthly'"
        floatLabel="always">
        <mat-label>Date</mat-label>
        <input
          matInput
          [max]="todayDate"
          [matDatepicker]="yearDate"
          readonly
          formControlName="yearDate" />
        <mat-datepicker-toggle
          matSuffix
          [for]="yearDate"></mat-datepicker-toggle>
        <mat-datepicker
          #yearDate
          startView="multi-year"
          panelClass="year-month-picker"
          (yearSelected)="
            onChosenYearOnlyHandler($event, yearDate)
          "></mat-datepicker>
      </mat-form-field>
      <button
        class="btn-med mar-left-10"
        mat-raised-button
        type="submit"
        [disabled]="isLoading || !form.valid"
        (click)="onSearch()"
        [ngClass]="{ 'btn-white': !isLoading && form.valid }">
        Search
      </button>
    </div>
    <div *ngIf="listTitle" class="report-sub-title">{{ listTitle }}</div>
    <div
      fxLayout="column"
      fxFlex
      class="report-table custom-page-scroll"
      [hidden]="!(dataSource.data && dataSource.data.length > 0)">
      <table
        #reportTable
        mat-table
        [dataSource]="dataSource"
        matSort
        class="content-table">
        <ng-container
          *ngFor="
            let columnName of displayedColumns;
            let idx = index;
            trackBy: trackItem
          "
          [matColumnDef]="columnName">
          <ng-container [ngSwitch]="columnName">
            <ng-container *ngSwitchDefault>
              <th
                mat-header-cell
                *matHeaderCellDef
                class="content-header"
                mat-sort-header
                disableClear>
                <div>
                  {{ columnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
            <ng-container *ngSwitchCase="'actions'">
              <th mat-header-cell *matHeaderCellDef class="content-header">
                <div>
                  {{ columnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
          </ng-container>

          <ng-container>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="columnName">
                <ng-container *ngSwitchDefault>{{
                  element[columnName]
                }}</ng-container>
                <ng-container *ngSwitchCase="'uploadedDatetime'">
                  {{
                    (element[columnName] | momentParseZonePipe: 'DD/MM/YYYY') ??
                      ''
                  }}
                </ng-container>
                <ng-container *ngSwitchCase="'actions'">
                  <div class="action-container">
                    <button
                      matTooltip="Download"
                      mat-icon-button
                      (click)="downloadReport(element)"
                      [disabled]="isLoading">
                      <mat-icon>download</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let entry"
          class="content-row"></tr>
      </table>
    </div>
    <div [hidden]="!(dataSource.data && dataSource.data.length > 0)">
      <mat-paginator
        #paginator
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[1, 10, 15, 25, 50, 100]"></mat-paginator>
    </div>
    <div class="content-loading" *ngIf="isLoading">
      <mat-spinner class="margin-auto"></mat-spinner>
    </div>
  </div>
</div>
